import { injectable, interfaces } from 'inversify';

const INACTIVITY_TRIGGER = 60000;

export interface ITimerService {
  duration: number;
  startTimer(): void;
}

export namespace ITimerService {
  export const $: interfaces.ServiceIdentifier<ITimerService> = Symbol('TIMER_SERVICE');
}

@injectable()
export class TimerService implements ITimerService {
  private _duration = 0;
  private _interval: number = 0;
  private _lastTick?: number = undefined;

  constructor() {
    window.addEventListener('mousemove', () => {
      this.move();
    });
    window.addEventListener('keyup', () => {
      this.move();
    });
    window.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        this.move();
      } else {
        this.freeze();
      }
    });
  }

  get duration(): number {
    return this._duration;
  }

  startTimer(): void {
    window.clearInterval(this._interval);
    this._duration = 0;
    this._lastTick = Date.now();
    this._interval = window.setInterval(this.freeze.bind(this), INACTIVITY_TRIGGER);
  }

  private move(): void {
    const tick = Date.now();
    this._duration += tick - (this._lastTick || tick);
    this._lastTick = tick;
  }

  private freeze(): void {
    if (!this._lastTick) {
      return;
    }
    this._lastTick = undefined;
  }
}
